// @ts-nocheck
import { createReducer } from '@reduxjs/toolkit';
import { persistReducer, purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTableStateReducers } from '@/store/tableState.reducer';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

const PresentationTypes = {
  PRESENTATIONS_TABLE_STATE_SET: 'PRESENTATIONS/TABLE_STATE_SET',
  PRESENTATIONS_TABLE_STATE_RESET: 'PRESENTATIONS/TABLE_STATE_RESET',
};

// ---------------------------------------------------------------------------
// Actions
// ---------------------------------------------------------------------------

export const setPresentationsTableState = (queries) => ({
  type: PresentationTypes.PRESENTATIONS_TABLE_STATE_SET,
  payload: { queries },
});

export const resetPresentationsTableState = () => ({
  type: PresentationTypes.PRESENTATIONS_TABLE_STATE_RESET,
});

// ---------------------------------------------------------------------------
// Reducer
// ---------------------------------------------------------------------------

export const defaultTableQuery = {
  pageSize: 20,
  pageIndex: 0,
  sortBy: [],
  filterRoles: [],
  viewSlug: null,
  search: '',
  searchColumn: '',
  status: null,
};

const initialState = {
  tableState: defaultTableQuery,
};

const STORAGE_KEY = 'bigcapital:presentations';

const CONFIG = {
  key: STORAGE_KEY,
  whitelist: [],
  storage,
};

const reducerInstance = createReducer(initialState, {
  ...createTableStateReducers('PRESENTATIONS', defaultTableQuery),
});

export default persistReducer(CONFIG, reducerInstance);